import { render, staticRenderFns } from "./PeriodList.vue?vue&type=template&id=923125d4&scoped=true&"
import script from "./PeriodList.vue?vue&type=script&lang=js&"
export * from "./PeriodList.vue?vue&type=script&lang=js&"
import style0 from "./PeriodList.vue?vue&type=style&index=0&id=923125d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923125d4",
  null
  
)

export default component.exports